import EntityTypes from 'parts/types/EntityTypes'
import PaymentTypes from 'parts/types/PaymentTypes'

export function getCoursePrice(priceData: EntityTypes.TariffPrice) {
	return (
		priceData.price + ' ' + PaymentTypes.Currencies[priceData.currency].sign
	)
}
